import { default as judging } from ":src/modules/grading/judging/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/judge",
  judging,
  faq_inquiry,
  profile,
};
